import { render } from "./OfferFilter.vue?vue&type=template&id=4b570a84&scoped=true"
import script from "./OfferFilter.vue?vue&type=script&lang=js"
export * from "./OfferFilter.vue?vue&type=script&lang=js"

import "./OfferFilter.vue?vue&type=style&index=0&id=4b570a84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b570a84"

export default script